var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.58378L6.72896 7.62731L6.27012 5.66045L7.79845 4.33645L5.78814 4.1659L5 2.30634L4.21186 4.1659L2.20155 4.33645L3.72988 5.66045L3.27104 7.62731L5 6.58378ZM1.91 9.5L2.73 5.985L0 3.62L3.595 3.315L5 0L6.405 3.315L10 3.62L7.27 5.985L8.09 9.5L5 7.635L1.91 9.5Z",
    fill: "#01875F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarEmpty);
export default __webpack_public_path__ + "static/media/ratingStarEmpty.e84847029ccfc0cf81e5fa93cd39d960.svg";
export { ForwardRef as ReactComponent };